
/**
 * Module dependencies.
 */

import {
  acceptLanguageHeader,
  handleRequestError,
  request
} from 'src/core/utils/requests';

import { getApiEndpoint } from 'src/core/utils/api-url-resolver';

/**
 * Export `FormDataProps` type.
 */

export type FormDataProps = {
  company?: string | null,
  countryAlpha2: string,
  districtId?: string | null,
  email: string,
  message: string,
  name: string,
  phone?: string | null,
  place?: string | null,
  professionalType?: string | null,
  recaptchaToken: string,
  subject: string
};

/**
 * `Query` type.
 */

type Query = {
  formData: FormDataProps,
  locale: string
};

/**
 * Export `submitTalkToUsForm`.
 */

export async function submitTalkToUsForm({ formData, locale }: Query) {
  const endpoint = getApiEndpoint('talkToUsForm');

  try {
    const { data } = await request.post(endpoint, formData, {
      headers: acceptLanguageHeader(locale)
    });

    return data?.data;
  } catch (error) {
    throw handleRequestError(error);
  }
}
